import getConversationSortByProperty from 'owa-mail-triage-table-utils/lib/getConversationSortByProperty';
import MailFolderTableQuery from 'owa-mail-list-store/lib/store/schema/MailFolderTableQuery';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import { appendConversationWithSeekToConditionResponse } from 'owa-mail-list-response-processor';
import { findConversationWithSeekToInstanceKeyCondition } from '../../services/findConversationWithSeekToInstanceKeyCondition';
import { onLoadMoreRowsSucceeded, onLoadMoreRowsFailed } from './onLoadMoreRowsCompleted';
import { getBaseFolderId, getBaseServerFolderId } from 'owa-mail-list-store';
import { getMailboxInfoFromTableQuery } from 'owa-mail-mailboxinfo';
import getHashtagsToInclude from 'owa-mail-inbox-plus-store/lib/selectors/getHashtagsToInclude';
import getHashtagsToExclude from 'owa-mail-inbox-plus-store/lib/selectors/getHashtagsToExclude';
import { getFindConversationsRestrictions } from 'owa-mail-find-rows';

/**
 * Load more conversations from the server
 * @param tableView to load
 */
export default function loadMoreConversationsFromServer(tableView: TableView, rowsToLoad: number) {
    const lastRowIndex = tableView.rowKeys.length - 1;
    const mailTableQuery = tableView.tableQuery as MailFolderTableQuery;
    const findConversationRestrictions = getFindConversationsRestrictions(tableView);

    // We always perform seek to condition request when we are loading more.
    // We use instancekey of the last item we have in the loaded rows in the table.
    // The seekToCondition ask server to get items from this instanceKey the response of which will also
    // include the last item who instanceKey we used.
    findConversationWithSeekToInstanceKeyCondition(
        getBaseFolderId(mailTableQuery),
        tableView.rowKeys[lastRowIndex],
        rowsToLoad,
        mailTableQuery.viewFilter,
        getConversationSortByProperty(mailTableQuery),
        mailTableQuery.focusedViewFilter,
        mailTableQuery.requestShapeName,
        getMailboxInfoFromTableQuery(mailTableQuery).requestOptions,
        mailTableQuery.categoryName,
        getHashtagsToInclude(mailTableQuery.inboxClassificationFilter),
        getHashtagsToExclude(mailTableQuery.inboxClassificationFilter),
        getBaseServerFolderId(tableView, true /* returnNullIfSameAsFolderId */),
        findConversationRestrictions /* restriction required for static folders */,
        findConversationRestrictions /* refinerRestriction required for search folders*/
    ).then(
        responseMessage => {
            if (responseMessage.ResponseClass === 'Success') {
                onLoadMoreRowsSucceeded(
                    tableView,
                    responseMessage.Conversations,
                    responseMessage.TotalConversationsInView,
                    appendConversationWithSeekToConditionResponse
                );
            } else {
                onLoadMoreRowsFailed(tableView, responseMessage.ResponseCode);
            }
        },
        (error: any) => {
            onLoadMoreRowsFailed(tableView);
        }
    );
}
